var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-px-md q-py-xs",attrs:{"id":"LandfillManagement"}},[_c('crud-layout',{ref:"crudLayout",attrs:{"name":_vm.name,"id":_vm.id,"page":_vm.page,"pageDetail":_vm.pageDetail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }